import React from 'react';
import './StoreInfoSection.scss';

const StoreInfoSection = () => {
  return (
    <section className="store-info-section">
      <div className="text-content">
        <h2>Spectacular Store With Spectacular Creations</h2>
        <p>In over 82 years of long span, so many renowned people have visited our showroom in Satara. With new ideas and amendments in the gold business, our current generation has now made it to the global map. This very website of ours has been visited by so many renowned people and we have never missed to fetch accolades for our design and work ethics. In today’s world, which is growing...</p>
      </div>
      <div className="image-content">
        <img src="images/schemes/devi_jwellers.jpg" alt="Store" />
      </div>
    </section>
  );
};

export default StoreInfoSection;
